<figure class="resseler-item-container">

<div class="resseler-item-subcontainer">
<div *ngIf="reseller.blackFriday" class="black-friday">
    <span>Black Friday Deals</span>
</div>

    <div class="reseller ">
        <div class="res_logo">
            <img [src]="enviroment.serverData + reseller.logo.path">
        </div>

        <h4>{{reseller.name}}</h4>
        <div class="mails">
            <div *ngIf="reseller.mainEmail" class="d-flex justify-content-start mb-1">
                <div class="ress_icon mr-1">
                    <img [src]="imgUrl +  'svg/sale.svg'">
                </div>
                <a href="mail:{{reseller.mainEmail}}">{{reseller.mainEmail}}</a>
            </div>
            <div *ngIf="reseller.serviceEmail" class="d-flex justify-content-start mb-1">
                <div class="ress_icon mr-1">
                    <img [src]="imgUrl +  'svg/service.svg'">
                </div>
                <a href="mail:{{reseller.serviceEmail}}">{{reseller.serviceEmail}}</a>
            </div>
        </div>
        <div class="showroom d-flex justify-content-start" *ngIf="reseller.showroomAddress">
            <div class="ress_icon mr-1">
                <img [src]="imgUrl +  'svg/location.svg'">
            </div>
           <span>
                {{'Showroom' | translate}}<br/>
               {{reseller.showroomAddress}}
           </span>
        </div>
    </div>
</div>

<div *ngIf="reseller.url" class="link d-flex justify-content-end">
  <a [href]="reseller.url" target="_blank">{{'Visit website' | translate}}</a>
</div>

</figure>
